
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { LucideIcon } from "lucide-react";

interface FeatureCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  href: string;
}

const FeatureCard = ({ title, description, icon: Icon, href }: FeatureCardProps) => {
  return (
    <div className="detector-card group">
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 rounded-full bg-fraudeye-accent/10 text-fraudeye-accent">
          <Icon className="h-5 w-5" />
        </div>
        <h3 className="text-lg font-semibold">{title}</h3>
      </div>
      <p className="text-muted-foreground text-sm mb-4">{description}</p>
      <Link 
        to={href} 
        className="inline-flex items-center text-sm font-medium text-fraudeye-accent group-hover:text-fraudeye-highlight"
      >
        Try Now <ArrowRight className="ml-1 h-4 w-4" />
      </Link>
    </div>
  );
};

export default FeatureCard;
